type TurmaEnderecoLike = {
  endereco?: string | null;
  logradouro?: string | null;
  numero?: string | null;
  complemento?: string | null;
  bairro?: string | null;
  cidade?: string | null;
  uf?: string | null;
  cep?: string | null;
};

const limparParte = (valor?: string | null) => {
  const normalizado = valor?.trim();
  return normalizado ? normalizado : "";
};

export const montarEnderecoTurma = (turma?: TurmaEnderecoLike | null): string => {
  if (!turma) {
    return "";
  }

  const enderecoLegado = limparParte(turma.endereco);
  if (enderecoLegado) {
    return enderecoLegado;
  }

  const logradouro = limparParte(turma.logradouro);
  const numero = limparParte(turma.numero);
  const complemento = limparParte(turma.complemento);
  const bairro = limparParte(turma.bairro);
  const cidade = limparParte(turma.cidade);
  const uf = limparParte(turma.uf);
  const cep = limparParte(turma.cep);

  const linhaPrincipal = [logradouro, numero && `Nº ${numero}`].filter(Boolean).join(", ");
  const localizacao = [bairro, [cidade, uf].filter(Boolean).join(" - ")].filter(Boolean).join(", ");

  return [linhaPrincipal, complemento, localizacao, cep && `CEP ${cep}`]
    .filter(Boolean)
    .join(" | ");
};
